var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_788_6076",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_788_6076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1231 20.248C8.47051 19.8288 7.12019 18.9535 6.07212 17.6221C5.02404 16.2907 4.5 14.75 4.5 13C4.5 12.1012 4.65673 11.242 4.9702 10.4221C5.28367 9.60222 5.72245 8.84998 6.28655 8.16536C6.425 8.01025 6.5923 7.93012 6.78845 7.92499C6.9846 7.91985 7.16537 7.99998 7.33075 8.16536C7.46922 8.30383 7.54101 8.47274 7.54613 8.67209C7.55126 8.87144 7.48459 9.05893 7.34613 9.23456C6.90768 9.75765 6.5737 10.3403 6.3442 10.9826C6.11472 11.625 5.99997 12.2974 5.99997 13C5.99997 14.3756 6.41504 15.599 7.24518 16.6702C8.07531 17.7413 9.13781 18.4525 10.4327 18.8038C10.5981 18.8512 10.734 18.9442 10.8404 19.0826C10.9468 19.2211 11 19.373 11 19.5384C11 19.7884 10.9138 19.9852 10.7413 20.1288C10.5689 20.2724 10.3628 20.3121 10.1231 20.248ZM13.8769 20.2672C13.6371 20.3313 13.4311 20.289 13.2586 20.1403C13.0862 19.9916 13 19.7922 13 19.5423C13 19.3871 13.0532 19.2403 13.1596 19.1019C13.266 18.9634 13.4019 18.8673 13.5673 18.8134C14.8557 18.4198 15.9166 17.6948 16.75 16.6384C17.5833 15.582 18 14.3692 18 13C18 11.3333 17.4166 9.91663 16.25 8.74996C15.0833 7.58329 13.6666 6.99996 12 6.99996H11.6461L12.4692 7.82306C12.6141 7.96793 12.6865 8.14357 12.6865 8.34999C12.6865 8.55639 12.6141 8.73202 12.4692 8.87689C12.3244 9.02175 12.1487 9.09419 11.9423 9.09419C11.7359 9.09419 11.5603 9.02175 11.4154 8.87689L9.42117 6.88266C9.32759 6.78908 9.26157 6.69036 9.2231 6.58651C9.18463 6.48266 9.1654 6.37049 9.1654 6.24999C9.1654 6.12947 9.18463 6.01729 9.2231 5.91344C9.26157 5.8096 9.32759 5.71089 9.42117 5.61729L11.4154 3.62306C11.5603 3.4782 11.7359 3.40576 11.9423 3.40576C12.1487 3.40576 12.3244 3.4782 12.4692 3.62306C12.6141 3.76793 12.6865 3.94357 12.6865 4.14999C12.6865 4.35639 12.6141 4.53202 12.4692 4.67689L11.6461 5.49999H12C14.0923 5.49999 15.8653 6.22691 17.3192 7.68076C18.773 9.13459 19.5 10.9077 19.5 13C19.5 14.7333 18.9743 16.2666 17.923 17.5999C16.8717 18.9333 15.523 19.8224 13.8769 20.2672Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.91e489d1f03e1c978b541f52389f50c3.svg";
export { ForwardRef as ReactComponent };